<main>
  <loading-overlay [isLoading]="isLoading > 0" />
  <header>
    <div class="headline">
      <h1>
        {{ 'YarnQcDetails_Title' | translateWF: 'Yarn QC:' }}
        <!-- waiting for decision for to know if this is editable -->
        @if (isUpdate()) {
          @if (yarnQC()?.number) {
            {{ yarnQC()?.number }}
          } @else {
            null
          }
        } @else {
          {{ 'YarnQcDetails_New' | translateWF: 'New' }}
        }
      </h1>
    </div>
    <div class="buttons">
      @if (canEdit()) {
        <p-button [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" [disabled]="itemsMasterSelected().length <= 0" />
      }
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>
  <div class="content">
    <section>
      {{ yarnQC()?.number | json }}
    </section>

    <section>
      <div class="grid-2">
        <div class="span-1">
          <h2 class="mb-5">{{ 'YarnQcDetails_General' | translateWF: 'General' }}</h2>
          <div class="col">
            <div class="col-sm">
              <label for="">{{ 'YarnQcDetails_Invoice' | translateWF: 'Invoice' }}</label>
              <p-autocomplete
                [dropdown]="true"
                class="w-full"
                styleClass="w-full"
                [formControl]="invoiceSelected"
                #invoiceSearchRef="cslServerSearch"
                [cslServerSearch]="fetchInvoices"
                [suggestions]="invoiceSearchRef.results()"
                optionLabel="invoiceNumber"
                [disabled]="!canEdit()"
              />
            </div>
            <div class="col-sm">
              <label for="">{{ 'YarnQcDetails_Shipment' | translateWF: 'Shipment' }}</label>
              <input type="text" pInputText [disabled]="true" [value]="shipmentSelected.value?.shipmentNumber" />
            </div>
          </div>
        </div>
        <div class="span-1">
          <csl-standard-notes [userLite]="userLite!" [notes]="notes" (viewMore)="onViewMore()" />
        </div>
      </div>
    </section>

    <section>
      <div class="grid-4">
        <div class="col-sm">
          <label for="">{{ 'YarnQcDetails_Conditional' | translateWF: 'Conditional' }}</label>
          <textarea pTextarea [rows]="5" [disabled]="!invoiceSelected.value || !canEdit()" [formControl]="conditional"></textarea>
        </div>
        <div class="">
          <div class="col-sm" [ngClass]="{ 'opacity-50': !yarnQC() }">
            <h4 [ngClass]="{ 'text-gray-400': !yarnQC() }">
              {{ 'YarnQcDetails_AttachedYarnQcDocument' | translateWF: 'Attached Yarn QC Document' }}
            </h4>
            <input type="file" class="hidden" #fileInput (change)="uploadGeneralFile($event, fileInput)" />
            <button
              class="border-2 border-dashed p-3 rounded-lg font-semibold transition-all duration-200"
              [ngClass]="{
                'border-gray-300 text-gray-400 cursor-not-allowed bg-gray-100': !yarnQC() || !canEdit(),
                'border-gray-400 text-gray-700 hover:border-teal-500 hover:bg-teal-50': yarnQC() && canEdit(),
              }"
              (click)="yarnQC() && canEdit() ? fileInput.click() : null"
              [disabled]="!yarnQC() || !canEdit()"
            >
              {{ 'YarnQcDetails_DocumentsSupport' | translateWF: 'Documents Support' }}
              <span [ngClass]="{ 'text-teal-500': yarnQC(), 'text-gray-400': !yarnQC() }">{{ 'YarnQcDetails_browser' | translateWF: 'browser' }}</span>
            </button>
            <ul class="w-full grid-2 grid-flow-row-sm mt-3">
              @for (file of generalFiles(); track $index) {
                <li class="w-full row-between-center ps-2 py-1 rounded-lg bg-gray-300 cursor-pointer">
                  <a (click)="openFile(file.presignedUrl)" class="font-medium truncate">{{ file.name.split('/').pop() }}</a>
                  <p-button icon="pi pi-times" severity="secondary" class="p-button-sm" variant="text" (onClick)="deleteGeneralFile(file)" />
                </li>
              } @empty {
                <p-tag severity="info">{{ 'YarnQcDetails_NoFilesAttached' | translateWF: 'No files attached' }}</p-tag>
              }
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="under__line mb-[2rem] row-between-center">
        <h2>{{ 'YarnQcDetails_YarnToTested' | translateWF: 'Yarn to Tested' }}</h2>

        <p-autocomplete
          [dropdown]="true"
          [formControl]="yarnToTestedSelected"
          #itemMasterSearchRef="cslServerSearch"
          [cslServerSearch]="fetchItemMasters"
          [suggestions]="itemMasterSearchRef.results()"
          [disabled]="itemsMasterSelected().length <= 0 || !canEdit()"
          dropdownIcon="pi pi-search"
          optionLabel="baseYarnCode"
          (onSelect)="selectedItemMaster($event)"
        />
      </div>

      <p-table [value]="itemsMasterSelected()" dataKey="itemCode" expandableRows="true" [responsiveLayout]="'scroll'">
        <!-- HEADER TABLA PRINCIPAL -->
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th>{{ 'YarnQcDetails_YarnCode' | translateWF: 'Yarn Code' }}</th>
            <th>{{ 'YarnQcDetails_Description' | translateWF: 'Description' }}</th>
            <th>{{ 'YarnQcDetails_Provider' | translateWF: 'Provider' }}</th>
            <th>{{ 'YarnQcDetails_Manufacturer' | translateWF: 'Manufacturer' }}</th>
          </tr>
        </ng-template>

        <!-- FILA PRINCIPAL -->
        <ng-template pTemplate="body" let-yarn let-expanded="expanded">
          <tr>
            <!-- Botón expandir -->
            <td>
              <button
                type="button"
                pButton
                pRipple
                [pRowToggler]="yarn"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              ></button>
            </td>

            <!-- Datos del Yarn -->
            <td>{{ yarn.yarnBaseCode ?? yarn.itemCode }}</td>
            <td>{{ localHelperService.getLocalizedValue(yarn.itemDescription) }}</td>
            <td>{{ getProvider() }}</td>
            <td>{{ getManufacturer(yarn.itemCode) }}</td>
          </tr>
        </ng-template>

        <!-- FILA EXPANDIDA SOLO CON HEADER INTERNO -->
        <ng-template pTemplate="rowexpansion" let-yarn>
          <tr>
            <td colspan="5">
              <p-table [value]="uniqueLotGroups()" class="p-datatable-sm" [responsiveLayout]="'scroll'">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Lot Number</th>
                    <th>Status</th>
                    <th>files</th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-lotGroup>
                  <tr>
                    <td>
                      {{ lotGroup.group.value.manufacturerLotNumber }}
                    </td>
                    <td>
                      <p-select [options]="resultStatusTypeOptions()" appendTo="body" class="w-[12rem]" [formControl]="lotGroup.group.controls.resultStatus"></p-select>

                      @if (lotGroup.group.controls.resultStatus.value > 0 && lotGroup.group.controls.resultStatus.value != null) {
                        <div class="col-sm mt-5">
                          <label for="">Reason</label>
                          <p-select
                            class="ms-5 w-[12rem]"
                            [formControl]="lotGroup.group.controls.qualityDefectReference"
                            [options]="qualityDefectsTranslated()"
                            optionLabel="name"
                            optionValue="id"
                            [showClear]="true"
                            appendTo="body"
                            [disabled]="!canEdit()"
                          />
                        </div>
                      }
                    </td>
                    <td>-----</td>
                    <td></td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </div>
</main>
